/* eslint-disable consistent-return */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable array-callback-return */
import React, {
  useEffect, useRef, useState,
} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Tooltip, { TooltipPlacements, TooltipThemes } from '../../tooltip';
import Badge, { BadgeTypes, BadgeSizes } from '../../badge';

const BADGE_GAP = 9;

const RenBadges = ({ data, accessor, loading }) => {
  const containerRef = useRef(null);
  const moreItemsRef = useRef(null);

  // TODO: Kept 999 to show more badge by default for width calculation purpose
  const [hiddenItems, setHiddenItems] = useState([999]);

  const hiddenData = data[accessor].map((item, index) => {
    if (hiddenItems.includes(index)) return item;
  });

  const tooltipContent = hiddenData.filter((element) => element !== undefined).map(({ label }) => `• ${label} \n`).join('');

  const getWidths = () => ({
    containerWidth: containerRef.current.clientWidth,
    moreItemsWidth: moreItemsRef.current.clientWidth,
  });

  useEffect(() => {
    const { containerWidth, moreItemsWidth } = getWidths();
    let itemsWidth = 0;
    [...containerRef.current.children].map((child) => {
      itemsWidth += child.clientWidth;
    });
    itemsWidth += (BADGE_GAP * (containerRef.current.children.length - 1));
    const hiddenIndexes = [];
    if (containerWidth < itemsWidth - moreItemsWidth) {
      let totalSpaceLeft = containerWidth - moreItemsWidth;
      [...containerRef.current.children].map((child, index) => {
        totalSpaceLeft -= (child.clientWidth + BADGE_GAP);
        if (totalSpaceLeft < 0) {
          hiddenIndexes.push(index);
        }
      });
    }
    setHiddenItems(hiddenIndexes);
  }, [data[accessor]]);

  useEffect(() => {
    if (loading) {
      setHiddenItems([999]);
    }
  }, [loading]);

  const getBadge = (badgeProps, index) => {
    if (badgeProps.tooltip) {
      return (
        /* eslint-disable-next-line react/jsx-props-no-spreading */
        <Tooltip {...badgeProps.tooltip} key={index}>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <Badge {...badgeProps} />
        </Tooltip>
      );
    }
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    return (
      <Badge
        key={String(index)}
        className={clsx({ 'badge-hidden': hiddenItems.includes(index) }, badgeProps.className)}
        {...badgeProps}
      />
    );
  };

  const getMoreItemsBadge = () => (
    <div ref={moreItemsRef} className={clsx('badges-sm', { 'badges-sm-hidden': !hiddenItems.length })}>
      <Tooltip
        description={tooltipContent}
        placement={TooltipPlacements.RIGHT}
        theme={TooltipThemes.LIGHT}
      >
        <Badge
          key={`+ ${hiddenItems.length - 1}`}
          label={`+ ${hiddenItems.length - 1}`}
          type={BadgeTypes.GRAY}
          size={BadgeSizes.SMALL}
          showDot={false}
          showRemove={false}
        />
      </Tooltip>
    </div>
  );

  const getBadges = () => {
    const badges = data[accessor].filter((badgeData, index) => (
      !hiddenItems.includes(index)
    ));

    return badges.map((badgeProps, index) => getBadge(badgeProps, index));
  };

  return (
    <div className="tbl-ren-badges" ref={containerRef}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      {getBadges()}
      {getMoreItemsBadge()}
    </div>
  );
};

RenBadges.defaultProps = {
  data: {},
  id: '',
  loading: false,
};

RenBadges.propTypes = {
  id: PropTypes.string,
  accessor: PropTypes.string.isRequired,
  data: PropTypes.shape(),
  loading: PropTypes.bool,
};

export default RenBadges;
